<template>
  <div>
    <input type="checkbox">
    <label>{{ name }}</label>
  </div>
</template>
<script>
export default {
  name: 'Tag',
  props: ['name']
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Trg/Tags/InputTag.vue